import type { TOC } from '@ember/component/template-only';

interface GeneralNotificationDotSignature {
  Args: {};
}

const GeneralNotificationDot = <template>
  <div class="notification-dot"></div>
</template> satisfies TOC<GeneralNotificationDotSignature>;

export default GeneralNotificationDot;
